import React from 'react';
import { ButtonLink } from '../../../components';
import { t } from '../../../i18n';
import UrlTo from '../../../url-to';
import { userGreenIcon } from '../../assets/index';
import './styles.scss';

const GuestMobileNavbar = () => {
  return (
    <>
      <div className="courses-header__guest-wrapper courses-header__guest-wrapper_mobile">
        <div className="courses-header__guest-icon">
          <img src={userGreenIcon} alt="user" />
        </div>
        <div>
          <div className="courses-header__authentication-navbar-wrapper">{t('DIGITAL_COURSES.HEADER.LOGIN')}</div>
          <p>{t('DIGITAL_COURSES.HEADER.ADDITIONAL_INFO')}</p>
        </div>
      </div>
      <ButtonLink
        type="green"
        href={UrlTo.login({ role: 'Rider', returnUrl: UrlTo.coursesHome() })}
        text={t('DIGITAL_COURSES.HEADER.LOGIN')}
        className="courses-header__login-button"
      />
    </>
  );
};

export default GuestMobileNavbar;
